var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePickerCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.043,
    height: 18,
    viewBox: "0 0 22.043 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.2,579.216H22.328v-.924a.546.546,0,0,0-.547-.545h-.032a.546.546,0,0,0-.547.545v.924H17.43v-.924a.546.546,0,0,0-.547-.545h-.032a.546.546,0,0,0-.547.545v.924H12.532v-.924a.546.546,0,0,0-.547-.545h-.032a.546.546,0,0,0-.547.545v.924H6.532a.684.684,0,0,0-.686.682v15.167a.684.684,0,0,0,.686.682H27.2a.684.684,0,0,0,.686-.682V579.9A.684.684,0,0,0,27.2,579.216Zm-20.23,1.121h4.433v1.033a.546.546,0,0,0,.547.545h.032a.546.546,0,0,0,.547-.545v-1.033H16.3v1.033a.546.546,0,0,0,.547.545h.032a.546.546,0,0,0,.547-.545v-1.033H21.2v1.033a.546.546,0,0,0,.547.545h.032a.546.546,0,0,0,.547-.545v-1.033h4.433v3.049H6.973Zm9.3,14.289h-9.3V584.508H26.761v1.168h0v8.951Z",
    transform: "translate(-5.846 -577.748)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerCalendar);
export default __webpack_public_path__ + "static/media/datePickerCalendar.ff0ed414.svg";
export { ForwardRef as ReactComponent };